export default {
  statusTemplates: [],
  pagination: {},
  statusTemplate: {}
}
